{
  "chainId": 4663,
  "name": "Robinhood Chain",
  "permit2": "0x000000000022D473030F116dDEE9F6B43aC78BA3",
  "routers": [
    {
      "address": "0x204FAca1764B154221e35c0d20aBb3c525710498",
      "name": "Universal Router 2.1.2",
      "usesPermit2": true
    }
  ],
  "feeds": [
    {
      "feed": "0xe86e3422Aa9B5e8ee9f3E41a63975bC387A8bce9",
      "maxAge": 90000,
      "symbol": "LINK",
      "token": "0x492641F648a4986844848E0beFE66D14817bCE34"
    },
    {
      "feed": "0x61B7e5650328764B076A108EFF5fa7282a1B9aD2",
      "maxAge": 90000,
      "symbol": "USDG",
      "token": "0x5fc5360D0400a0Fd4f2af552ADD042D716F1d168"
    },
    {
      "feed": "0x78F3556b67E17Df817D51Ef5a990cDaF09E8d3A9",
      "maxAge": 90000,
      "symbol": "WETH",
      "token": "0x0Bd7D308f8E1639FAb988df18A8011f41EAcAD73"
    },
    {
      "feed": "0x0009cD492adf8167f9eEBf1293556A673530a21a",
      "maxAge": 90000,
      "symbol": "cbBTC",
      "token": "0xCEC185eB182c47d1bA1EFc84e6959e18cd620Be4"
    },
    {
      "feed": "0x6B22A786bAa607d76728168703a39Ea9C99f2cD0",
      "maxAge": 100800,
      "symbol": "AAPL",
      "token": "0xaF3D76f1834A1d425780943C99Ea8A608f8a93f9"
    },
    {
      "feed": "0x943A29E7ae51A4798823ca9eEd2ed533B2A22C72",
      "maxAge": 100800,
      "symbol": "AMD",
      "token": "0x86923f96303D656E4aa86D9d42D1e57ad2023fdC"
    },
    {
      "feed": "0xD5a1508ceD74c084eBf3cBe853e2C968fB2a651C",
      "maxAge": 100800,
      "symbol": "AMZN",
      "token": "0x12f190a9F9d7D37a250758b26824B97CE941bF54"
    },
    {
      "feed": "0xB4106147E8cce40b7d46124090d373A71b70f87D",
      "maxAge": 100800,
      "symbol": "ASML",
      "token": "0x47F93d52cBeC7C6D2CfC080e154002370a60dAEA"
    },
    {
      "feed": "0x62Cc8F9b5f56a33c9C8A60c8B92779f523c4E984",
      "maxAge": 100800,
      "symbol": "BABA",
      "token": "0xad25Ac6C84D497db898fa1E8387bf6Af3532a1c4"
    },
    {
      "feed": "0xA3a468A452940B7D6b69991207B508c609a98Ef2",
      "maxAge": 100800,
      "symbol": "COIN",
      "token": "0x6330D8C3178a418788dF01a47479c0ce7CCF450b"
    },
    {
      "feed": "0x6652eDf64bA3731C4F2D3ce821A0Fb1f1f6b482a",
      "maxAge": 100800,
      "symbol": "CRCL",
      "token": "0xdF0992E440dD0be65BD8439b609d6D4366bf1CB5"
    },
    {
      "feed": "0xe1b3aABCAFAd1c94708dc1367dcfF8Aa4407487C",
      "maxAge": 100800,
      "symbol": "CRWV",
      "token": "0x5f10A1C971B69e47e059e1dC91901B59b3fB49C3"
    },
    {
      "feed": "0x1C6c8cADBe02E19129c39dDB92281cE4c0bf206b",
      "maxAge": 100800,
      "symbol": "DELL",
      "token": "0x941AE714EC6D8130c7B75d67160Ca08f1e7d11Dd"
    },
    {
      "feed": "0xEFdf54610B62A7753Ec30bDc380847c12D32e1D1",
      "maxAge": 100800,
      "symbol": "EWY",
      "token": "0x7f0aBeF0C07280F82c6a08ead09dEd6BAE2C13Fc"
    },
    {
      "feed": "0x27C71df6A64fB476468EdF256CF72c038baB5B67",
      "maxAge": 100800,
      "symbol": "GME",
      "token": "0x1b0E319c6A659F002271B69dB8A7df2F911c153E"
    },
    {
      "feed": "0xF6f373a037c30F0e5010d854385cA89185AE638b",
      "maxAge": 100800,
      "symbol": "GOOGL",
      "token": "0x2e0847E8910a9732eB3fb1bb4b70a580ADAD4FE3"
    },
    {
      "feed": "0x3f390C5C24628Ac7C489515402235FeAD71D1913",
      "maxAge": 100800,
      "symbol": "INTC",
      "token": "0xc72b96e0E48ecd4DC75E1e45396e26300BC39681"
    },
    {
      "feed": "0x7C38C00C30BEe9378381E7B6135d7283356D71b1",
      "maxAge": 100800,
      "symbol": "META",
      "token": "0xc0D6457C16Cc70d6790Dd43521C899C87ce02f35"
    },
    {
      "feed": "0x45C3C877C15E6BA2EBB19eA114Ea508d14C1Af2E",
      "maxAge": 100800,
      "symbol": "MSFT",
      "token": "0xe93237C50D904957Cf27E7B1133b510C669c2e74"
    },
    {
      "feed": "0x396118bdFB181e6240E74D243F266B061c0edc3D",
      "maxAge": 100800,
      "symbol": "MSTR",
      "token": "0xec262a75e413fAfD0dF80480274532C79D42da09"
    },
    {
      "feed": "0x425EEFdCf05ed6526C3cE61Af99429A228a6d596",
      "maxAge": 100800,
      "symbol": "MU",
      "token": "0xfF080c8ce2E5feadaCa0Da81314Ae59D232d4afD"
    },
    {
      "feed": "0xE1D87B116Ba0fe898998f1D140339D1fA1E09705",
      "maxAge": 100800,
      "symbol": "NBIS",
      "token": "0x9D9c6684F596F66a64C030B93A886D51Fd4D7931"
    },
    {
      "feed": "0x379EC4f7C378F34a1B47E4F3cbeBCbAC3E8E9F15",
      "maxAge": 100800,
      "symbol": "NVDA",
      "token": "0xd0601CE157Db5bdC3162BbaC2a2C8aF5320D9EEC"
    },
    {
      "feed": "0x0e6a64a2B58A6693a531E6c555f3A5d042eEA844",
      "maxAge": 100800,
      "symbol": "ORCL",
      "token": "0xb0992820E760d836549ba69BC7598b4af75dEE03"
    },
    {
      "feed": "0x820ABedFF239034956B7A9d2F0a331f9F075eB4c",
      "maxAge": 100800,
      "symbol": "PLTR",
      "token": "0x894E1EC2D74FFE5AEF8Dc8A9e84686acCB964F2A"
    },
    {
      "feed": "0x80901d846d5D7B030F26B480776EE3b29374C2ae",
      "maxAge": 100800,
      "symbol": "QQQ",
      "token": "0xD5f3879160bc7c32ebb4dC785F8a4F505888de68"
    },
    {
      "feed": "0x045477BF65Aef6f4F2386ad0164579e48381CC74",
      "maxAge": 100800,
      "symbol": "RKLB",
      "token": "0x3b14C39E89D60D627b42a1A4CA45b5bb45Fc12e2"
    },
    {
      "feed": "0xa0DF4ee0fFf975306345875E3548Fcc519577A11",
      "maxAge": 100800,
      "symbol": "SGOV",
      "token": "0x92FD66527192E3e61d4DDd13322Aa222DE86F9B5"
    },
    {
      "feed": "0x209b73908e92Ae021826eD79609845451Ecba2ce",
      "maxAge": 100800,
      "symbol": "SLV",
      "token": "0x411eFb0E7f985935DAec3D4C3ebaEa0d0AD7D89f"
    },
    {
      "feed": "0xfb133Fa4B7b385802B693a293606682Df47109A3",
      "maxAge": 100800,
      "symbol": "SNDK",
      "token": "0xB90A19fF0Af67f7779afF50A882A9CfF42446400"
    },
    {
      "feed": "0xB265810950ba6c5C0Ff821c9963014a56fD8Bffb",
      "maxAge": 100800,
      "symbol": "SPCX",
      "token": "0x4a0E65A3EcceC6dBe60AE065F2e7bb85Fae35eEa"
    },
    {
      "feed": "0x319724394D3A0e3669269846abE664Cd621f9f6A",
      "maxAge": 100800,
      "symbol": "SPY",
      "token": "0x117cc2133c37B721F49dE2A7a74833232B3B4C0C"
    },
    {
      "feed": "0x4A1166a659A55625345e9515b32adECea5547C38",
      "maxAge": 100800,
      "symbol": "TSLA",
      "token": "0x322F0929c4625eD5bAd873c95208D54E1c003b2d"
    },
    {
      "feed": "0x874cF94aa8eC88Fd9560094dD065f2fB3E41Fc2F",
      "maxAge": 100800,
      "symbol": "TSM",
      "token": "0x58FfE4a942d3885bAa22D7520691F611EF09e7AA"
    },
    {
      "feed": "0xA994d3684e8400A6c8078226925779FdeE682DD9",
      "maxAge": 100800,
      "symbol": "USAR",
      "token": "0xd917B029C761D264c6A312BBbcDA868658eF86a6"
    },
    {
      "feed": "0x75a9c76Ef439e2C7c2E5a34Ab105EcFe3766431c",
      "maxAge": 100800,
      "symbol": "USO",
      "token": "0xa30FA36Db767ad9eD3f7a60fC79526fB4d56D344"
    }
  ],
  "v3Fallback": {
    "_comment": "Keyless execution path used only when the Uniswap Trading API is not configured: Uniswap v3 single pools into WETH (the deepest pool for each), quoted with QuoterV2.",
    "quoter": "0x33e885ed0ec9bf04ecfb19341582aadcb4c8a9e7",
    "hub": "0x0Bd7D308f8E1639FAb988df18A8011f41EAcAD73",
    "feeToHub": {
      "0x5fc5360D0400a0Fd4f2af552ADD042D716F1d168": 100,
      "0xCEC185eB182c47d1bA1EFc84e6959e18cd620Be4": 500
    }
  }
}
